export default __webpack_public_path__ + "static/media/review1.aca33cb2.gif";